/**
 * DriverDetailView - Driver detail modal using EntityDetailModal base
 *
 * Tabs:
 * - Overview: Driver info, license, certifications, assigned vehicles
 * - Events: Unified timeline (assignments, documents)
 * - Coûts: Cost breakdown (expenses)
 * - Documents: Document management
 *
 * ALL ACCORDIONS CLOSED BY DEFAULT
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { User, Calendar, Euro, FileText } from 'lucide-react';
import EntityDetailModal from '../../common/EntityDetailModal.jsx';
import { EventsTab, CoutsTab, DocumentsTab } from '../../common/tabs/index.js';
import DriverOverviewTab from '../tabs/DriverOverviewTab.jsx';

// Tab configuration for drivers — `label` = repli FR, le libellé affiché vient de t('drivers.detail.tabs.<id>')
const DRIVER_TABS = [
  {
    id: 'overview',
    label: "Vue d'ensemble",
    icon: User,
    component: DriverOverviewTab
  },
  {
    id: 'events',
    label: 'Événements',
    icon: Calendar,
    component: EventsTab
  },
  {
    id: 'couts',
    label: 'Coûts',
    icon: Euro,
    component: CoutsTab
  },
  {
    id: 'documents',
    label: 'Documents',
    icon: FileText,
    component: DocumentsTab
  }
];

function DriverDetailView({ driver, onClose, onMessage, onUpdate }) {
  const { t } = useTranslation();
  if (!driver) return null;
  const tabs = DRIVER_TABS.map(tab => ({ ...tab, label: t(`drivers.detail.tabs.${tab.id}`, { defaultValue: tab.label }) }));

  return (
    <EntityDetailModal
      isOpen={!!driver}
      onClose={onClose}
      onUpdate={onUpdate}
      onMessage={onMessage}
      entity={driver}
      entityType="driver"
      tabs={tabs}
      colorScheme="blue"
      headerTitle={`${driver.first_name} ${driver.last_name}`}
      headerSubtitle={driver.email}
    />
  );
}

export default DriverDetailView;
